export default {
  buttons: {
    start: 'Start tilberedning af planlagt ordre',
  },
};
